import React from 'react';
import {View, StyleSheet} from 'react-native';
import {MaterialCommunityIcons} from '@expo/vector-icons';

type TickCheckProps = {
  size?: number;
  color?: string;
  backgroundColor?: string;
};

const TickCheck: React.FC<TickCheckProps> = ({
  size = 11,
  color = '#3DAB9E',
  backgroundColor = 'rgba(61,171,158,0.14)',
}) => {
  const circleSize = size + 7;
  return (
    <View
      style={[
        styles.circle,
        {
          width: circleSize,
          height: circleSize,
          borderRadius: circleSize / 2,
          backgroundColor,
        },
      ]}>
      <MaterialCommunityIcons name="check" size={size} color={color} />
    </View>
  );
};

const styles = StyleSheet.create({
  circle: {
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default TickCheck;
